<div>
	<h4>Impersonate</h4>
	<div class="flex gap-4 items-end">
		<app-input [(ngModel)]="businessId" label="Business id"></app-input>
		<app-input [(ngModel)]="uid" label="User Id"></app-input>
		<app-input [(ngModel)]="matterId" label="Matter Id"></app-input>
		<app-button (click)="impersonate()" [loading]="loading">Submit</app-button>
	</div>
	<div *ngIf="error">Error attempting to impersonate user</div>
</div>
